// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconFont/icon/iconfont.css";
import VueAMap from "vue-amap";
import App from "./App";
import "./assets/css/reset.css";
import "./tools/formatDate";
import router from "./router";
import store from "./store/index";
import globalVariable from "./APIService/global_variable";
//资源请求
import VueResource from "vue-resource";
import echarts from "echarts";
import "swiper/css/swiper.min.css";
import "swiper/js/swiper.min.js";

import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);

import * as Quill from "quill";
import { ImageDrop } from "quill-image-drop-module";
Quill.register("modules/imageDrop", ImageDrop);

import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageResize", ImageResize);

import CodeEditor from "bin-code-editor";
Vue.use(CodeEditor);

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAMap);
Vue.use(VueResource);
Vue.prototype.$echarts = echarts;
Vue.prototype.GLOBAL = globalVariable;

if(localStorage.getItem('AMAP_JSAPI_KEY')){
  
  if(localStorage.getItem('AMAP_JSAPI_SECURITY'))
  {
    window._AMapSecurityConfig = {
      securityJsCode: localStorage.getItem('AMAP_JSAPI_SECURITY'),
    }
  }
  VueAMap.initAMapApiLoader({
    key: localStorage.getItem('AMAP_JSAPI_KEY'),
    // key:store.getters.getParameters.find(e=>e.parameter_id=="CRM_GAODE_KEY").parameter_value,
    plugin: ['AMap.Autocomplete',
        'AMap.PlaceSearch',
        'AMap.Scale',
        'AMap.OverView',
        'AMap.ToolBar',
        'AMap.MapType',
        'AMap.Driving',
        'AMap.InfoWindow',
        'AMap.MarkerClusterer',
        'AMap.PolyEditor',
        'AMap.CircleEditor',
        "AMap.Geolocation"], //定位控件
    // 默认高德 sdk 版本为 1.4.4
    // v: '1.4.4',
    uiVersion: '1.0' // 版本号
  })

}

Vue.prototype.error = function(err = "加载失败") {
  if (typeof err === "object") {
    err = "加载失败";
  }
  this.$message.error(err);
};

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js